import React from "react";
import { components } from "react-select";

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isSelected,
  children,
  innerProps,
  data,
  ...rest
}) => {
  const checked = data?.value === "select-all"
    ? (rest.selectProps?.value?.length || 0) >=
      (rest.selectProps?.options?.length - 1 || 0)
    : isSelected;

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isSelected={checked}
      getStyles={getStyles}
      innerProps={{ ...innerProps }}
      data={data}
    >
      <input type="checkbox" checked={checked} />
      <label htmlFor="checkbox">
        <span></span>
      </label>
      {children}
    </components.Option>
  );
};

export default InputOption;